import React from 'react';

import MaterialIcon from '@/components/atom/MaterialIcon';
import Overlay from '@/components/molecules/overlay';
import { CustomBackgroundColorModalProps } from '@/types/modal';

const CustomBackgroundColorModal = ({ body, onClickOverlay, backgroundColor }: CustomBackgroundColorModalProps) => {
  return (
    <Overlay index={10} onClickOverlay={onClickOverlay} backgroundColor={backgroundColor}>
      <button className='absolute top-8 right-8 text-white' type='button' onClick={onClickOverlay}>
        <MaterialIcon name='close' color='white' size={24} />
      </button>
      {body}
    </Overlay>
  );
};

export default CustomBackgroundColorModal;
